import { useQuery } from "react-query";
import { getRequest } from "../../apiRequest";
import { apiRoutes } from "../../Constants/ApiRoutes";
import { queryKeys } from "./queryKeys";

function fetchAvailableFeatures(product) {
  const pathParams = { ...(product && { product }) };
  return getRequest(apiRoutes.availableFeatures, null, pathParams).then(
    (res) =>
      res?.data?.data?.availableFeatures ??
      res?.data?.availableFeatures ??
      {}
  );
}

export function useAvailableFeatures(product) {
  return useQuery(
    queryKeys.availableFeatures(product),
    () => fetchAvailableFeatures(product),
    {
      staleTime: 5 * 60 * 1000,
    }
  );
}
